import { render, staticRenderFns } from "./single-more-spec-panel.vue?vue&type=template&id=06f7f853&scoped=true&"
import script from "./single-more-spec-panel.vue?vue&type=script&lang=js&"
export * from "./single-more-spec-panel.vue?vue&type=script&lang=js&"
import style0 from "./single-more-spec-panel.vue?vue&type=style&index=0&id=06f7f853&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f7f853",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("F:\\haohao\\QW\\allnet_crm\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06f7f853')) {
      api.createRecord('06f7f853', component.options)
    } else {
      api.reload('06f7f853', component.options)
    }
    module.hot.accept("./single-more-spec-panel.vue?vue&type=template&id=06f7f853&scoped=true&", function () {
      api.rerender('06f7f853', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/components/single-more-spec-panel.vue"
export default component.exports